<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row mb-3">
              <div class="col-6 col-lg-6">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" :value="filters.search" @input="updateSearch" />
                </div>
              </div>
              <div class="col-6 col-lg-6">
                <label>Client</label>
                <multiselect
                  :options="clients"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="clientSelected"
                  label="display_name"
                  track-by="id"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [useQueryParamFilters()],

  components: { Multiselect },

  data() {
    return {
      filters: {
        search: null,
        client_id: null,
      },
    }
  },

  computed: {
    ...mapState('clientsList', ['clients']),

    clientSelected: {
      get() {
        return this.clients.find(({ id }) => id === parseInt(this.filters.client_id)) || null
      },
      set(value) {
        this.filters.client_id = value ? value.id : null
      },
    },
  },

  created() {
    this.getClients()
  },

  methods: {
    ...mapActions('clientsList', ['getClients']),

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750),
  },

  watch: {
    queryParams: {
      handler(params) {
        this.$emit('input', params)
      },
      immediate: true,
    },
  },
}
</script>
